module.exports = __webpack_public_path__ + "img/1673510900450-Screenshot_2023-01-10-16-43-56-451_com.android.chrome.jpg.9d6d08de.webp";